module.exports = __webpack_public_path__ + "static/media/zulekha.7cbeb0b7.png";